import * as React from "react";
import { Info } from "lucide-react";
import { Alert } from "@/components/ui";

/**
 * Shown on TotalExpert routes while the account has no TotalExpert connection. Calm on purpose:
 * the route works without it, so this explains what connecting adds rather than warning.
 */
export function CrmConnectionNote() {
  return (
    <Alert className="bg-blue-50/50 border-blue-100 text-blue-900" data-testid="crm-connection-note">
      <Info />
      <Alert.Description className="text-blue-900">
        <span>
          <strong className="font-semibold">TotalExpert isn't connected to your account yet.</strong> Your route still
          works: clients reach the right form and player. Connecting TotalExpert lets SocialCoach fill in each client's
          details from TotalExpert automatically. Reach out to your account rep to learn more.
        </span>
      </Alert.Description>
    </Alert>
  );
}
